import React from "react"
import ReactDOM from "react-dom/client"
import "./tailwind.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

const doc: any = document
const root = ReactDOM.createRoot(doc.getElementById("root"))
root.render(<App />)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

/*
function sendHeight() {
	const maxWidth = Math.ceil(Math.max(
		document.body.scrollWidth,
		document.body.offsetWidth,
		document.documentElement.clientWidth,
		document.documentElement.scrollWidth,
		document.documentElement.offsetWidth
	));

	window.parent.postMessage(
		{
			type: 'iframe-height',
			height: document.documentElement.scrollHeight
		},
		'*'
	);


	window.parent.postMessage({
		type: 'iframe-width',
		width: maxWidth
	}, '*');
}

window.addEventListener('load', sendHeight);
window.addEventListener('resize', sendHeight);
new ResizeObserver(sendHeight).observe(document.body);
*/

function sendHeight() {
	const height = Math.ceil(Math.max(
		document.body.scrollHeight,
		document.body.offsetHeight,
		document.documentElement.scrollHeight,
		document.documentElement.offsetHeight
	));

	window.parent.postMessage({
		type: 'iframe-height',
		height
	}, '*');
}

window.addEventListener('load', sendHeight);
window.addEventListener('resize', sendHeight);

new ResizeObserver(sendHeight).observe(document.body);
new ResizeObserver(sendHeight).observe(document.documentElement);

setTimeout(sendHeight, 100);
setTimeout(sendHeight, 500);
setTimeout(sendHeight, 1500);